import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const APP_INSIGHTS_CONNECTION_STRING = ''

export const BROWSER_INFO_EVENT_NAME = 'BrowserInfo';
export const PLAYER_STATS_EVENT_NAME = 'PlayerStats';

export const appInsights = {

  instance: process.env.NODE_ENV !== 'development'
    ? new ApplicationInsights({
      config: {
        connectionString: APP_INSIGHTS_CONNECTION_STRING,
        enableAutoRouteTracking: true,
      }
    })
    : null,

  trackEvent: function (event: any) {
    if (this.instance) {
      //this.instance.trackEvent(event);
    }
  }
};

